export default __webpack_public_path__ + "cb30e242a424e48d50d75a3913ef126d.svg";